document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js-custom-popup").forEach(button => {
        button.addEventListener("click", function () {
            const targetClass = this.getAttribute("data-target");
            const parentBox = this.closest("section");

            if (parentBox && targetClass) {
                const popup = parentBox.querySelector(`.js-image-popup.${targetClass}`);
                if (popup) {
                    popup.classList.add("active");
                    document.body.classList.add("active");
                }
            }
        });
    });

    document.querySelectorAll(".js-close-popup").forEach(button => {
        button.addEventListener("click", function () {
            const popup = this.closest(".js-image-popup");
            if (popup) {
                popup.classList.remove("active");
                document.body.classList.remove("active");
            }
        });
    });

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            document.querySelectorAll(".js-image-popup.active").forEach(popup => {
                popup.classList.remove("active");
            });
            document.body.classList.remove("active");
        }
    });

    document.addEventListener("rebuy:cart.change", function () {
        document.querySelectorAll(".js-image-popup.active").forEach(popup => {
            popup.classList.remove("active");
        });
        document.body.classList.remove("active");
    });
});
